/** Backend preference codes (LanguageEnum: us | fr) */
export type PreferenceLanguage = 'us' | 'fr';

/** Map stored preference / legacy codes to i18n resource keys. */
export function preferenceLanguageToI18n(
  language: string | null | undefined
): 'en-US' | 'fr' {
  const code = (language || 'us').toLowerCase();
  if (code === 'fr' || code === 'fr-fr') {
    return 'fr';
  }
  return 'en-US';
}

/** Map i18n or localStorage language to backend preference code. */
export function i18nLanguageToPreference(
  language: string | null | undefined
): PreferenceLanguage {
  const code = (language || '').toLowerCase();
  if (code === 'fr' || code.startsWith('fr-')) {
    return 'fr';
  }
  return 'us';
}

/** Read language from GET /preferences API wrapper ({ data: { language } }). */
export function getPreferenceLanguageFromApi(
  preferencesResponse: { data?: { language?: string }; language?: string } | null | undefined
): string | undefined {
  const lang = preferencesResponse?.data?.language ?? preferencesResponse?.language;
  return typeof lang === 'string' ? lang : undefined;
}

/** True when saving preferences for the logged-in user (not another user's profile). */
export function isOwnPreferencesTarget(
  me: { uid?: string; id?: string | number } | null | undefined,
  targetUserId: string | undefined
): boolean {
  if (!targetUserId) {
    return true;
  }
  if (!me) {
    return false;
  }
  return (
    String(me.uid) === String(targetUserId) || String(me.id) === String(targetUserId)
  );
}
